import * as React from 'react'
import { Button, StyleSheet, Text, View, Image, SafeAreaView, ActivityIndicator } from 'react-native'
import { useAuthStore } from '../../../stores/auth'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { en as welcomeEn } from '../../../i18n/WelcomeScreen'
import { useInitializeStore } from '../../../stores/initialize'
import Card from '../../../components/shared/card/Card'
import { globalStyles } from '../../../static/styles/global'
import { useEffect } from 'react'
import { useHomeStore } from '../../../stores/home'

export default function Maintenance({ message }) {
    const homeStore = useHomeStore()


    if (homeStore.loading) {
        return <ActivityIndicator size={"large"} />
    }

    return (
        <SafeAreaView style={[
            globalStyles.flexOne,
            globalStyles.hDirection,
            globalStyles.lighterBgColor,
            { marginBottom: 0 }
        ]}>

            <Card style={{
                flex: 1, alignItems: 'center',
                justifyContent: 'center',
                marginBottom: 0
            }} >

                <Image
                    source={require('../../../../src/static/images/Maintenance.jpg')}
                    style={{ width: 280, height: 280 }}
                />

                <Text style={{ paddingTop: 5, textAlign: "center" }}>{message} </Text>

            </Card>


        </SafeAreaView >
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center'
    },
})
